/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_splitOidcToken } from '../models/Body_splitOidcToken';
import type { CompleteSigningRequest } from '../models/CompleteSigningRequest';
import type { CompleteSigningResponse } from '../models/CompleteSigningResponse';
import type { OAuthResponseType } from '../models/OAuthResponseType';
import type { OAuthTokenResponse } from '../models/OAuthTokenResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OidcSskService {
    /**
     * Split-OIDC authorization endpoint. Authorization-code flow only.
     * Split-OIDC authorization endpoint. Authorization-code flow only.
     * @param responseType
     * @param clientId
     * @param redirectUri
     * @param scope
     * @param state
     * @param nonce
     * @param codeChallenge
     * @param codeChallengeMethod
     * @returns void
     * @throws ApiError
     */
    public static authorize(
        responseType: OAuthResponseType,
        clientId: string,
        redirectUri: string,
        scope: string,
        state?: (string | null),
        nonce?: (string | null),
        codeChallenge?: (string | null),
        codeChallengeMethod?: 'S256',
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/oidc-ssk/authorize',
            query: {
                'response_type': responseType,
                'client_id': clientId,
                'redirect_uri': redirectUri,
                'scope': scope,
                'state': state,
                'nonce': nonce,
                'code_challenge': codeChallenge,
                'code_challenge_method': codeChallengeMethod,
            },
            errors: {
                303: `Redirect to login page`,
                400: `Invalid request (unvalidated redirect_uri or client)`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Store the device's sigma2 (live-session bound, one-shot); return RP redirect.
     * Store the device's sigma2 (live-session bound, one-shot); return RP redirect.
     * @param requestBody
     * @param mfaAuthenticatedSession
     * @returns CompleteSigningResponse Successful Response
     * @throws ApiError
     */
    public static completeSigning(
        requestBody: CompleteSigningRequest,
        mfaAuthenticatedSession?: (string | null),
    ): CancelablePromise<CompleteSigningResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/oidc-ssk/complete-signing',
            cookies: {
                'mfa_authenticated_session': mfaAuthenticatedSession,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `No live IdP session, or code/session/one-shot rejected`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Split-OIDC token endpoint: combine sigma1*sigma2 into the signed ID token.
     * Split-OIDC token endpoint: combine sigma1*sigma2 into the signed ID token.
     * @param formData
     * @param authorization
     * @returns OAuthTokenResponse Successful Response
     * @throws ApiError
     */
    public static splitOidcToken(
        formData: Body_splitOidcToken,
        authorization?: (string | null),
    ): CancelablePromise<OAuthTokenResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/oidc-ssk/token',
            headers: {
                'authorization': authorization,
            },
            formData: formData,
            mediaType: 'application/x-www-form-urlencoded',
            errors: {
                400: `Unsupported grant_type or redirect_uri mismatch`,
                401: `Invalid/expired/replayed code or client auth failure`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * OIDC discovery for the split-key OP (SSK issuer, endpoints, jwks_uri).
     * OIDC discovery for the split-key OP (SSK issuer, endpoints, jwks_uri).
     * @returns any Successful Response
     * @throws ApiError
     */
    public static splitOidcDiscovery(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/oidc-ssk/.well-known/openid-configuration',
        });
    }
    /**
     * JWKS holding only the tenant's split public key (no KMS key).
     * JWKS holding only the tenant's split public key (no KMS key).
     * @returns any Successful Response
     * @throws ApiError
     */
    public static splitOidcKeys(): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/oidc-ssk/keys',
            errors: {
                404: `Tenant has no active SSK certificate`,
            },
        });
    }
}
